import { faCompass } from '@fortawesome/pro-regular-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { Body } from '@growtherapy/sprout-ui';

import { useTrackEvent } from '../../segment/segment';
import { EventTypeEnum } from '../../segment/types';
import { Toast } from '../../toasts/Toast';
import { ToastButton } from '../../toasts/ToastButton';
import { ToastRenderFnProps, ToastVariant } from '../../toasts/types';
import { DataChannelMessageType } from '../../video-sdk';

interface ProviderUpdatedIntentionToastProps extends ToastRenderFnProps {
  messageType: DataChannelMessageType.SESSION_INTENTION_SET | DataChannelMessageType.SESSION_INTENTION_EDITED;
  appointmentShortId: string;
  sessionIntentionShortId: string;
  onViewClick: () => void;
}

export function ProviderUpdatedIntentionToast({
  messageType,
  appointmentShortId,
  sessionIntentionShortId,
  onViewClick,
  contentProps,
  titleProps,
  ...toastAriaProps
}: ProviderUpdatedIntentionToastProps): JSX.Element {
  const t = useTranslate();
  const { userClicked } = useTrackEvent();
  const providerSetSessionIntention = messageType === DataChannelMessageType.SESSION_INTENTION_SET;

  const handleViewClick = () => {
    userClicked(EventTypeEnum.CLIENT_CLICKED_PROVIDER_INTENTION_VIEW, {
      appointmentShortId,
      sessionIntentionShortId,
      trigger: providerSetSessionIntention ? 'intention_set' : 'intention_edited',
    });
    onViewClick();
  };

  return (
    <Toast variant={ToastVariant.Info} icon={faCompass} {...toastAriaProps}>
      <div className='flex flex-wrap xs:flex-nowrap items-center' {...contentProps}>
        <Body.Small as='span' {...titleProps}>
          {providerSetSessionIntention
            ? t('telehealth-core:intentions.yourProviderSetYourIntention')
            : t('telehealth-core:intentions.yourProviderEditedYourIntention')}
        </Body.Small>
        <ToastButton use='link' onClick={handleViewClick}>
          {t('telehealth-core:core.view')}
        </ToastButton>
      </div>
    </Toast>
  );
}
